import React, { Component } from 'react';
import { request } from 'http';
import Q from './shared/Q'
import AmcAns from './shared/AmcAns'

export default class Head extends Component {
	state = {
		ans:-1
	}
	onAns(ans) {
		this.setState({ans})
		global.setValid(true)
		global.setAnswer('Gender', ans, true);
	}
	Ans = {
		"Male" : "Male",
		"Female" : "Female",
		"Other" : "Other",
	}
	render() {
		const {t,l} = this.props
		const {ans} = this.state
		return <Q q="What is your Gender?" {...this.props}>
			{Object.keys(this.Ans).map((k,i) => <AmcAns on={ans === k} cb={_ => this.onAns(k)} ans={this.Ans[k]} 
			style={{
				position:"absolute",
				left: 20,
				top: 200 + 40 * i,
				width:360 - 48,
				height:30,
			}}/>)}
		</Q>	
	}
}



// WEBPACK FOOTER //
// ./src/dComp/Gender.js